import fontawesome from "@fortawesome/fontawesome";
import faTwitter from "./assets/fontawesome/fontawesome-pro-brands/faTwitter";
import faFacebook from "./assets/fontawesome/fontawesome-pro-brands/faFacebook";
import faExclamationTriangle from "./assets/fontawesome/fontawesome-pro-solid/faExclamationTriangle";
import faBars from "./assets/fontawesome/fontawesome-pro-solid/faBars";
import faTimes from "./assets/fontawesome/fontawesome-pro-regular/faTimes";
import faPencil from "./assets/fontawesome/fontawesome-pro-regular/faPencil";

fontawesome.library.add(faTwitter);
fontawesome.library.add(faFacebook);
fontawesome.library.add(faExclamationTriangle);
fontawesome.library.add(faBars);
fontawesome.library.add(faTimes);
fontawesome.library.add(faPencil);



// WEBPACK FOOTER //
// ./src/icons.js